import React from "react";

/*
 * Progress tracks from the showcase:
 *   light   → #E5E7EB track, Royal Blue fill (cards, rows)
 *   dark    → white/20 track, Sky Blue fill (mini-player on navy)
 *   overlay → white/30 track, Royal Blue fill (thumbnail bottom edge)
 */

const THEMES = {
  light: { track: "bg-ic-lightGray", fill: "bg-ic-blue" },
  dark: { track: "bg-white/20", fill: "bg-ic-sky" },
  overlay: { track: "bg-white/30", fill: "bg-ic-blue" },
};

export default function ProgressBar({ value = 0, theme = "light", height = 4, rounded = true, className = "" }) {
  const t = THEMES[theme] || THEMES.light;
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div
      className={`${t.track} ${rounded ? "rounded-sm" : ""} overflow-hidden ${className}`}
      style={{ height }}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className={`h-full ${t.fill}`} style={{ width: `${pct}%` }} />
    </div>
  );
}
